import '../scss/styles.scss';

import { initHeader } from './sections/header';
import { initHero } from './sections/hero';
import { initAbout } from './sections/about';
import { initArtists } from './sections/artists';
import { initFeedback } from './sections/feedback';
import { initFooter } from './sections/footer';
import { initModal } from './utils/modal';

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initHero();
  initArtists({ limit: 8, page: 1 });
  initAbout();
  initFeedback();
  initFooter();
  initModal();
});
